/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkLanguageDTO
 */
export interface WorkLanguageDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkLanguageDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkLanguageDTO
     */
    language?: string;
}

/**
 * Check if a given object implements the WorkLanguageDTO interface.
 */
export function instanceOfWorkLanguageDTO(value: object): value is WorkLanguageDTO {
    return true;
}

export function WorkLanguageDTOFromJSON(json: any): WorkLanguageDTO {
    return WorkLanguageDTOFromJSONTyped(json, false);
}

export function WorkLanguageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkLanguageDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'language': json['language'] == null ? undefined : json['language'],
    };
}

export function WorkLanguageDTOToJSON(json: any): WorkLanguageDTO {
    return WorkLanguageDTOToJSONTyped(json, false);
}

export function WorkLanguageDTOToJSONTyped(value?: WorkLanguageDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'language': value['language'],
    };
}


